import { Injectable, Injector, ComponentFactoryResolver } from '@angular/core';
import { DynamicHTMLOptions } from './options';
function isBrowserPlatform() {
    return window != null && window.document != null;
}
var DynamicHTMLRenderer = (function () {
    function DynamicHTMLRenderer(options, cfr, injector) {
        var _this = this;
        this.options = options;
        this.cfr = cfr;
        this.injector = injector;
        this.componentFactories = new Map();
        this.componentRefs = new Map();
        this.options.components.forEach(function (_a) {
            var selector = _a.selector, component = _a.component;
            var cf;
            cf = _this.cfr.resolveComponentFactory(component);
            _this.componentFactories.set(selector, cf);
        });
    }
    DynamicHTMLRenderer.prototype.renderInnerHTML = function (elementRef, html) {
        var _this = this;
        if (!isBrowserPlatform()) {
            throw new Error('dynamic-html supports only browser platform.');
        }
        elementRef.nativeElement.innerHTML = html;
        var componentRefs = [];
        this.options.components.forEach(function (_a) {
            var selector = _a.selector;
            var elements = elementRef.nativeElement.querySelectorAll(selector);
            Array.prototype.forEach.call(elements, function (el) {
                var content = el.innerHTML;
                var cmpRef = _this.componentFactories.get(selector).create(_this.injector, [], el);
                // remove `ng-version` attribute
                el.removeAttribute('ng-version');
                if (cmpRef.instance.dynamicOnMount) {
                    var attrsMap_1 = new Map();
                    if (el.hasAttributes()) {
                        Array.prototype.forEach.call(el.attributes, function (attr) {
                            attrsMap_1.set(attr.name, attr.value);
                        });
                    }
                    cmpRef.instance.dynamicOnMount(attrsMap_1, content, el);
                }
                componentRefs.push(cmpRef);
            });
        });
        this.componentRefs.set(elementRef, componentRefs);
        return {
            check: function () { return componentRefs.forEach(function (ref) { return ref.changeDetectorRef.detectChanges(); }); },
            destroy: function () {
                componentRefs.forEach(function (ref) { return ref.destroy(); });
                _this.componentRefs.delete(elementRef);
            },
        };
    };
    return DynamicHTMLRenderer;
}());
export { DynamicHTMLRenderer };
DynamicHTMLRenderer.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DynamicHTMLRenderer.ctorParameters = function () { return [
    { type: DynamicHTMLOptions, },
    { type: ComponentFactoryResolver, },
    { type: Injector, },
]; };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/~/ng-dynamic/src/dynamic-html/renderer.js
// module id = ../../../../ng-dynamic/src/dynamic-html/renderer.js
// module chunks = 3